<template>
  <div
    v-if="!itemValue" 
    class="location-btn"
    :class="{'disabled': readonly}"
    @click="uploadLocation()"
  >
    <van-icon 
      class="icon"
      name="location-o" 
    />
    <p class="text">点击上传位置</p>
  </div>
  <div v-else class="location-text" :class="{'disabled': readonly}">
    <p class="text">{{ itemValue }}</p>
    <van-icon 
      class="icon" 
      name="replay" 
      @click="uploadLocation()"
    />
  </div>
</template>

<script>
import { Toast, Icon } from 'vant';
import { api } from "@/utils/fetch.js";

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      loading: null
    };
  },
  computed: {

  },
  components: {
    [Icon.name]: Icon
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || null;
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    },
    uploadLocation () {
      if (this.readonly) {
        return;
      }
      const _this = this;
      window.wx.ready(function () {
        const loading = Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        window.wx.getLocation({
          type: 'gcj02',
          success: function (res) {
            console.log(res);
            loading.clear();
            _this.getLocationAddres(res.latitude, res.longitude);
          },
          fail: function () {
            console.log('getLocation error');
            _this.itemValue = '获取失败';
            this.onValueChange();
            loading.clear();
          }
        })
      });
    },
    getLocationAddres (latitude, logitude) {
      this.loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      api.GetGeocoder({
        latitude: latitude,
        logitude: logitude
      }).then(res => {
        console.log(res);
        if (res.result && res.result.address) {
          this.itemValue = res.result.address;
          this.onValueChange();
        } else {
          this.itemValue = '获取失败';
          this.onValueChange();
        }
        this.loading.clear();
      }).catch(e => {
        console.log(e);
        this.itemValue = '获取失败';
        this.onValueChange();
        this.loading.clear();
      })
    },
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.location-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  color: @desc-color-1;
  .input-item();
  .icon {
    font-size: @font-size-2;
    margin-right: 4px;
  }
  &.disabled {
    .text {
      color: var(--van-gray-5);
    }
  }
}
.location-text {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: var(--theme-main-color);
  .input-item();
  height: auto;
  .text {
    color: @title-color;
  }
  .icon {
    font-size: @font-size-2;
    margin-right: 4px;
    margin-top: 2px;
  }
  &.disabled {
    .text {
      color: var(--van-gray-5);
    }
  }
}
</style>
